

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('circle', {"cx":"15","cy":"15","r":"15","fill":"#42CC05"}, []), h('path', {"fill":"#FFF","d":"M22.657 10.343a1 1 0 0 0-1.414 0L14 17.586l-3.88-3.879a1 1 0 0 0-1.327-.078l-.087.078a1 1 0 0 0 0 1.414l4.243 4.243a1 1 0 0 0 .66.292 1 1 0 0 0 1.269-.12l7.778-7.779a1 1 0 0 0 0-1.414Z"}, [])])]);
};

        